module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "left": "false",
      "title": "支付",
      "fixed": false
    }
  }), _vm._v(" "), (_vm.location) ? _c('div', [_vm._v(_vm._s(_vm.location))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openInBrowser),
      expression: "openInBrowser"
    }],
    staticClass: "browser-tipbox"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.safari),
      expression: "safari"
    }],
    attrs: {
      "src": "/static/images/openInSafari.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.safari),
      expression: "!safari"
    }],
    attrs: {
      "src": "/static/images/openInBrowser.png"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61754002"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Pay.vue
// module id = 569
// module chunks = 0